import { Languages } from 'typings'

export const getLanguageArg = (languagePath: string): string => {
  // * There are only these 2 values as per current store PF.
  const language = languagePath === Languages.EN ? 'english' : 'local'
  return language
}
